// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2biVs","amount":"Amount_amount__3cl0V","tip":"Amount_tip___AHsz","tipHeader":"Amount_tipHeader__13Gq7","tipsWrap":"Amount_tipsWrap__1fNxn"};